<template>
    <article
        class="group flex h-full flex-col rounded-12 bg-[#FFFFFF0D] p-3 max-lg:space-y-2 lg:flex-row lg:space-x-5"
        @mouseenter="isHover = true"
        @mouseleave="isHover = false">
        <BaseVideoPoster
            ref="poster"
            show-play
            :alt="item.title || ''"
            :second-image="
                getMediaLink(
                    item.image?.[1]?.webp_url || item.image?.[1]?.url || '',
                    400
                )
            "
            :video="item.video?.length ? getMediaLink(item.video[0].url) : null"
            :poster="
                getMediaLink(
                    item.preview_video?.[0]?.webp_url ||
                        item.preview_video?.[0]?.url ||
                        '',
                    400
                )
            "
            :active="isActive"
            :image="
                getMediaLink(
                    item.image?.[0]?.webp_url || item.image?.[0]?.url || '',
                    400
                )
            "
            class="sm:max-w-[12.5rem]" />
        <div class="space-y-1 lg:space-y-3">
            <div
                v-html="item.title"
                class="text-16/150 font-semibold text-ash-200 lg:text-24/133" />
            <div
                v-html="item.text"
                class="tinyeditor text-16/132 text-accent-100" />
        </div>
    </article>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import BaseVideoPoster from '~/components/base/base-video-poster/BaseVideoPoster.vue'
import type { IThesesSectionItem } from '~/components/particles/theses-section/theses-section.types'

const props = defineProps({
    item: {
        type: Object as PropType<IThesesSectionItem>,
        required: true,
    },
    active: {
        type: Boolean,
        default: false,
    },
})

const isHover = ref<boolean>(false)
const isActive = computed<boolean>(() => {
    return props.active || isHover.value
})
</script>
